<template>
  <div>
    <div class="mt-4 text-center">
      <v-dialog v-model="dialog" width="1000px" persistent>
        <v-card>
          <v-card-title class="primary py-3">
            <span class="headline white--text"> Importar Proyección MO</span>
          </v-card-title>
          <v-card-text class="pa-5">
            <v-form ref="formArchive" v-model="validArchive" lazy-validation>
              <v-row>
                <v-col cols="10">
                  <v-file-input
                    dense
                    v-model="archive"
                    show-size
                    label="Archivo"
                    clearable
                    id="files"
                    ref="files"
                    :rules="rulesArchive"
                    prepend-icon="mdi-file"
                  ></v-file-input>
                </v-col>
                <v-col cols="2" class="d-flex align-center justify-end">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        class="white--text mr-1"
                        fab
                        small
                        v-on="on"
                        @click="handleFilesUpload(archive)"
                      >
                        <v-icon dark>mdi-cloud-upload</v-icon>
                      </v-btn>
                    </template>
                    <span>CARGAR ARCHIVO</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" class="white--text mx-1" fab small @click="exportarModelo()" v-on="on">
                        <v-icon dark>mdi-file-table</v-icon>
                      </v-btn>
                    </template>
                    <span>DESCARGAR FORMATO</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                  <v-data-table
                    dense
                    :headers="headerDetalle"
                    :items="listado"
                    class="border"
                    multi-sort
                    :mobile-breakpoint="0"
                    :items-per-page="-1"
                    no-results-text="No se encontraron datos"
                    no-data-text="No se encontraron datos"
                    :search="search"
                    item-class="class"
                    :fixed-header="true"
                    :height="height"
                  >
                  </v-data-table>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="close()"> Cancelar </v-btn>
            <v-btn color="primary" text @click="guardar()"> Aceptar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div v-if="showLoading" class="progress-background">
        <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import MatrizService from '../services/MatrizService';
import moment from 'moment';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx/xlsx.mjs';
export default {
  name: 'Importar',
  props: {
    dialog: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    height: 130,
    search: '',
    archive: null,
    validArchive: true,
    rulesArchive: [
      (value) => !!value || 'Campo requerido.',
      (value) => !value || value.size < 4000000 || 'El archivo debe de tener menos de 4MB!',
      (value) => {
        if (value === null || value === undefined) return true;
        const res = value.name.slice(value.name.lastIndexOf('.') + 1, value.name.length).toLowerCase();
        if (res == 'csv' || res == 'xlsx' || res == 'xls') return true;
        return "Formatos aceptados son '.csv', '.xlsx' , '.xls'";
      }
    ],
    headerDetalle: [
      { text: 'N°', value: 'numero', width: '60', class: 'primary' },
      { text: 'EMPRESA', value: 'idempresa', width: '120', class: 'primary' },
      { text: 'LOCACIÓN', value: 'idlocacionbudget', width: '120', class: 'primary' },
      { text: 'CULTIVO ÁREA', value: 'cultivoarea', width: '160', class: 'primary' },
      { text: 'S1', value: 'S1', width: '100', class: 'primary' },
      { text: 'S2', value: 'S2', width: '100', class: 'primary' },
      { text: 'S3', value: 'S3', width: '100', class: 'primary' },
      { text: 'S4', value: 'S4', width: '100', class: 'primary' },
      { text: 'S5', value: 'S5', width: '100', class: 'primary' },
      { text: 'S6', value: 'S6', width: '100', class: 'primary' },
      { text: 'S7', value: 'S7', width: '100', class: 'primary' },
      { text: 'S8', value: 'S8', width: '100', class: 'primary' },
      { text: 'S9', value: 'S9', width: '100', class: 'primary' },
      { text: 'S10', value: 'S10', width: '100', class: 'primary' },
      { text: 'S11', value: 'S11', width: '100', class: 'primary' },
      { text: 'S12', value: 'S12', width: '100', class: 'primary' },
      { text: 'S13', value: 'S13', width: '100', class: 'primary' },
      { text: 'S14', value: 'S14', width: '100', class: 'primary' },
      { text: 'S15', value: 'S15', width: '100', class: 'primary' },
      { text: 'S16', value: 'S16', width: '100', class: 'primary' },
      { text: 'S17', value: 'S17', width: '100', class: 'primary' },
      { text: 'S18', value: 'S18', width: '100', class: 'primary' },
      { text: 'S19', value: 'S19', width: '100', class: 'primary' },
      { text: 'S20', value: 'S20', width: '100', class: 'primary' },
      { text: 'S21', value: 'S21', width: '100', class: 'primary' },
      { text: 'S22', value: 'S22', width: '100', class: 'primary' },
      { text: 'S23', value: 'S23', width: '100', class: 'primary' },
      { text: 'S24', value: 'S24', width: '100', class: 'primary' },
      { text: 'S25', value: 'S25', width: '100', class: 'primary' },
      { text: 'S26', value: 'S26', width: '100', class: 'primary' },
      { text: 'S27', value: 'S27', width: '100', class: 'primary' },
      { text: 'S28', value: 'S28', width: '100', class: 'primary' },
      { text: 'S29', value: 'S29', width: '100', class: 'primary' },
      { text: 'S30', value: 'S30', width: '100', class: 'primary' },
      { text: 'S31', value: 'S31', width: '100', class: 'primary' },
      { text: 'S32', value: 'S32', width: '100', class: 'primary' },
      { text: 'S33', value: 'S33', width: '100', class: 'primary' },
      { text: 'S34', value: 'S34', width: '100', class: 'primary' },
      { text: 'S35', value: 'S35', width: '100', class: 'primary' },
      { text: 'S36', value: 'S36', width: '100', class: 'primary' },
      { text: 'S37', value: 'S37', width: '100', class: 'primary' },
      { text: 'S38', value: 'S38', width: '100', class: 'primary' },
      { text: 'S39', value: 'S39', width: '100', class: 'primary' },
      { text: 'S40', value: 'S40', width: '100', class: 'primary' },
      { text: 'S41', value: 'S41', width: '100', class: 'primary' },
      { text: 'S42', value: 'S42', width: '100', class: 'primary' },
      { text: 'S43', value: 'S43', width: '100', class: 'primary' },
      { text: 'S44', value: 'S44', width: '100', class: 'primary' },
      { text: 'S45', value: 'S45', width: '100', class: 'primary' },
      { text: 'S46', value: 'S46', width: '100', class: 'primary' },
      { text: 'S47', value: 'S47', width: '100', class: 'primary' },
      { text: 'S48', value: 'S48', width: '100', class: 'primary' },
      { text: 'S49', value: 'S49', width: '100', class: 'primary' },
      { text: 'S50', value: 'S50', width: '100', class: 'primary' },
      { text: 'S51', value: 'S51', width: '100', class: 'primary' },
      { text: 'S52', value: 'S52', width: '100', class: 'primary' }
    ],
    listado: [],
    showLoading: false
  }),
  methods: {
    close() {
      this.listado = [];
      this.archivo = null;
      this.validArchive = true;
      this.height = 130;
      this.$emit('close');
    },
    async handleFilesUpload(archivo) {
      if (this.$refs.formArchive.validate()) {
        this.listado = [];
        var f = archivo;
        var reader = new FileReader(archivo);
        reader.onload = (e) => {
          var data = e.target.result;
          data = new Uint8Array(data);

          var workbook = XLSX.read(data, {
            type: 'array'
          });

          /* DO SOMETHING WITH workbook HERE */
          var first_sheet_name = workbook.SheetNames[0];
          /* Get worksheet */
          var worksheet = workbook.Sheets[first_sheet_name];
          //It will prints with header and contents ex) Name, Home...
          var json = XLSX.utils.sheet_to_json(worksheet, {
            header: 1
          });
          json.shift();
          var detallesAux = [];
          json.forEach((element) => {
            if (element[0] != null) {
              let object = { numero: detallesAux.length + 1 };
              this.headerDetalle.forEach((element1, index) => {
                if (index > 0) {
                  object[element1.value] = element[index - 1] ? element[index - 1] : '';
                }
                object[element1.value] = object[element1.value] == '' ? null : object[element1.value];
              });
              detallesAux.push(object);
            }
          });
          if (detallesAux.length > 0) {
            this.listado = detallesAux;
            this.height = 400;
          }
        };
        reader.readAsArrayBuffer(f);
      }
    },
    async alertDialog(type, title) {
      return await Swal.fire({
        icon: type,
        title: title,
        confirmButtonText: `OK`
      });
    },
    async guardar() {
      const confirmed = await Swal.fire({
        icon: 'warning',
        title: '¿Está seguro de importar la información?',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true
      });
      if (confirmed.isConfirmed) {
        if (this.listado.length == 0) {
          this.alertDialog('error', 'No tiene información para importar');
        } else {
          this.$emit('importar', this.listado);
        }
      }
    },
    async exportarModelo() {
      const confirmed = await Swal.fire({
        icon: 'warning',
        title: '¿Está seguro de exportar el modelo de importación?',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true
      });
      if (confirmed.isConfirmed) {
        this.showLoading = true;
        const fecha1 = moment().format('YYYYMMDDHHMMSS');
        const nombreentregable = 'EXPORT-MODELO-PROYECCION-MO-' + fecha1 + '.xlsx';
        const token = localStorage.getItem('token');
        await this.matrizService.downloadResource(
          'exportarModeloProyeccionMO',
          {
            token: token
          },
          nombreentregable
        );
        this.showLoading = false;
      }
    }
  },
  async created() {
    this.matrizService = this.$httpService(new MatrizService(), this);
  }
};
</script>
<style lang="scss">
.header-items-fixed-ind {
  position: sticky !important;
  position: -webkit-sticky !important;
}

.header-items-fixed-ind.nth-child1 {
  left: 0;
  z-index: 4 !important;
}
.header-items-fixed-ind.nth-child2 {
  top: 0;
  left: 100px;
  border-right: thin solid rgba(250, 250, 250) !important;
  z-index: 4 !important;
}
.class-items-fixed-ind td:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 3;
}
.class-items-fixed-ind td:nth-child(2) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 100px;
  z-index: 3;
}
.cell-d-none td:last-child {
  display: none;
}
.v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr > th {
  z-index: 3;
  color: white !important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr .header-items-fixed-ind {
  background: white;
  color: rgba(0, 0, 0, 0.6);
}
.theme--dark.v-data-table > .v-data-table__wrapper > table > thead > tr .header-items-fixed-ind {
  background: #1e1e1e;
  color: rgba(255, 255, 255, 0.7);
}
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > .class-items-fixed-ind td:nth-child(1) {
  background: white;
  color: rgba(0, 0, 0, 0.87);
}
.theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > .class-items-fixed-ind td:nth-child(1) {
  background: #1e1e1e;
  color: white;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > .class-items-fixed-ind td:nth-child(2) {
  background: white;
  color: rgba(0, 0, 0, 0.87);
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
.theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > .class-items-fixed-ind td:nth-child(2) {
  background: #1e1e1e;
  color: white;
  border-right: thin solid rgba(255, 255, 255, 0.12);
}

.text-field-search-matriz.theme--light.v-input input,
.theme--dark.v-input textarea {
  color: rgba(0, 0, 0, 0.87);
}
.text-field-search-matriz.theme--dark.v-input input,
.theme--dark.v-input textarea {
  color: rgba(0, 0, 0, 0.87) !important;
}

.text-field-search-matriz .v-input__control .v-input__slot .v-text-field__slot .theme--light.v-label {
  color: rgba(0, 0, 0, 0.6);
}

.text-field-search-matriz .v-input__control .v-input__slot .v-text-field__slot .theme--dark.v-label {
  color: rgba(0, 0, 0, 0.6);
}
</style>
